import { QueryClient } from "@tanstack/react-query";

export const queryClientConfig = new QueryClient({
   defaultOptions: {
      queries: {
         retry: 0, // reintentos si falla
         refetchOnWindowFocus: false, // reintenta si cambia de pestaña
      },
   },
});